import { Ability, subject } from '@casl/ability'
import { RadioGroupButtonOptionsType } from '../../components/RadioGroup/radioGroup.buttons'
import { ACTIONS, SUBJECTS, SubjectWithAttributes } from '../Permission'
import { IUser } from 'redux/store/user/types'

export const COGNUS_REPOSITORY_OPTIONS: (
  ability?: Ability
) => RadioGroupButtonOptionsType[] = (ability) => [
  {
    label: 'Available for evaluation',
    value: 'availabl_for_evaluation',
    disabled:
      ability?.cannot(ACTIONS.VIEW, SUBJECTS.AVAILABLE_FOR_EVALUATION) ?? true
  },
  {
    label: 'Opportunity analysis',
    value: 'opportunity_analysis',
    disabled:
      ability?.cannot(ACTIONS.VIEW, SUBJECTS.OPPORTUNITY_ANALYSIS) ?? true
  }
]
export const COGNUS_REPOSITORY_OPTIONS_EXTRA: (
  ability,
  user: IUser
) => RadioGroupButtonOptionsType[] = (ability, user) => [
  {
    label: 'Requests for analysis',
    value: 'requests_for_analysis',
    disabled: ability.cannot(
      ACTIONS.VIEW,
      subject(SUBJECTS.REQUESTS_FOR_ANALYSIS, {
        ...user
      } as unknown as SubjectWithAttributes)
    )
  }
]

export const COGNUS_REPOSITORY_OPTIONS_COMMONS = [
  { label: 'Opportunity analysis', value: 'opportunity_analysis' }
]

export const COGNUS_REPOSITORY_STATUS = {
  IN_REVIEW: 'in_review',
  ACCEPTED: 'accepted',
  TERMINATED: 'terminated'
} as const

export const COGNUS_REPOSITORY_STATUS_NAME = {
  [COGNUS_REPOSITORY_STATUS.IN_REVIEW]: 'In review',
  [COGNUS_REPOSITORY_STATUS.ACCEPTED]: 'Accepted',
  [COGNUS_REPOSITORY_STATUS.TERMINATED]: 'Terminated'
} as const
